<div
    class="avi-dropdown-option"
    id="avi-dropdown-option"
    avi-tooltip
    [positionsPriority]="tooltipPositionsPriority"
    [delay]="500"
    [hideTooltip]="!tooltipText && !optionSignpostTemplateRef"
    (onPositionChange)="handlePositionChange($event)"
    (click)="handleSelect()"
>
    <div
        *ngIf="optionTemplateRef; else defaultView"
        class="avi-dropdown-option__custom-template-container"
    >
        <ng-container
            [ngTemplateOutlet]="optionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: value, label, data: optionData }"
        ></ng-container>
    </div>
    <ng-template #defaultView>
        <span class="avi-dropdown-option__label sel-avi-dropdown-option__label">
            {{ label }}
        </span>
    </ng-template>
    <ng-template #aviTooltipContent>
        <div
            class="avi-dropdown-option__tooltip clr-wrapper {{ caretClassName }}"
            *ngIf="tooltipText"
        >
            {{ tooltipText }}
        </div>
        <signpost
            *ngIf="optionSignpostTemplateRef"
            [signpostPosition]="signpostPosition"
        >
            <ng-container
                [ngTemplateOutlet]="optionSignpostTemplateRef"
                [ngTemplateOutletContext]="{ $implicit: value, data: optionData }"
            ></ng-container>
        </signpost>
    </ng-template>
</div>
